import { Component } from '@angular/core';
import { User } from 'src/app/models/user';
import { AppState } from 'src/app/services/app.service';

@Component({
    selector: 'error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent {
    public constructor(private appState: AppState) {
        let user = this.appState.get('user') || {} as User;
        user.status = 'active';

        this.appState.updateUser(user);
    }
 }